import React, { Component } from 'react';
import './MainPage.css'

import categoryImage from "../../assets/images/category_descr.png"
import productImage from "../../assets/images/product_desc.png"
import statisticImage from "../../assets/images/statistic.png"
import agentsImage from "../../assets/images/agents-front.png"
import Footer from '../../components/Footer'
// import Logo from '../../components/Svgs/Logo'
import { Link } from "react-router-dom";

import Header from "../../components/Header/Header";
import Navigation from "../../components/Navigation/Navigation";
import Slider from "./Slider/Slider";
import FaAngleDoubleLeft from "react-icons/lib/fa/angle-double-left";
import PolicySearchModal from "../../components/PolicySearchModal/PolicySearchModal";
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
// import ScrollTop from '../../components/ScrollTop'
import FaChevronUp from "react-icons/lib/fa/chevron-up"
import ScrollToTop from 'react-scroll-up'
import PageLoader from '../../components/PageLoader'
import Chat from '../../components/Chat/Chat'

class MainPage extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const { translate, currentLocale } = this.props
        return (
            <div className="main">
                <Chat />
                <PageLoader />
                <div className="Head">
                    <Header />
                    <Navigation />
                </div>
                {/* <ScrollTop /> */}
                <div className="scrollButton">
                    <ScrollToTop showUnder={0} duration={500}>
                        <span className="ScrollTop" id="ScrollTop">
                            <FaChevronUp />
                        </span>
                    </ScrollToTop>
                </div>
                <Slider />
                <section className="main-info">
                    <div className="info-items">
                        {/* <a href="categorydescription"> */}
                        <Link to={"/" + currentLocale.code + "/" + translate("categorydescriptionUrl")}>
                            <div className="main-info-item" >
                                <div className="item-image" >
                                    <img src={categoryImage}
                                        alt="Compulsory Insurance Center"
                                        title="product details" />
                                </div>
                                <h3>{translate('categoriesDescription')}</h3>
                                <p>{translate('categoriesDescriptionText')}</p>
                                <button>{translate('detail')}</button>
                            </div>
                        </Link>
                        {/* </a> */}
                        <Link to={"/" + currentLocale.code + "/" + translate("productdetailsUrl")}>
                            <div className="main-info-item">
                                <div className="item-image" >
                                    <img src={productImage} alt="Compulsory Insurance Center" title="category description" />
                                </div>
                                <h3>{translate('productDetails')}</h3>
                                <p>{translate('productDetailsDescriptionText')}</p>
                                <button>{translate('detail')}</button>
                            </div>
                        </Link>
                        <Link to="">
                            <div className="main-info-item">
                                <div className="item-image">
                                    <img src={statisticImage}
                                        alt="Compulsory Insurance Center"
                                        title="Statistics" />
                                </div>
                                <h3>{translate('statistic')}</h3>
                                <p>{translate('statisticDescriptionText')}</p>
                                <button>{translate('detail')}</button>
                            </div>
                        </Link>
                    </div>
                </section>
                <section className="main-individual-person">
                    <div className="container">
                        <div className="individual-person-content">
                            <div className="individual-person-content-inner">
                                <div className="rectangle" />
                                <h3>{translate('portalIndividual')}
                                    <span>{translate('byPersons')}</span>
                                </h3>
                                <p>{translate('portalIndividualPersonsDescription')}</p>
                                <h1>{translate('us')}<span> {translate('about')}</span></h1>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="main-agents">
                    <div className="container">
                        <div className="agents-content">
                            <div className="agents-content-inner">
                                <div className="square" />
                                <h2 className="main-agents-header">{translate('portal')}<span>{translate('byAgents')}</span></h2>
                                <p className="main-agents-description">{translate('portalByAgentsDescriptionText')}</p>
                                <button className="main-agents-enter-btn" onClick={() => window.open(`${window.config.env.EXTERNAL_LINKS}`)}>
                                    {translate('enter')}
                                </button>
                                <h3>{translate('byAgents')}</h3>
                                <div className="main-agents-image-container">
                                    <FaAngleDoubleLeft className="main-agents-image-icon" />
                                    <img src={agentsImage}
                                        alt="Compulsory Insurance Center"
                                        title="portal for agents" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
    currentLocale: getActiveLanguage(state.locale)
});

export default connect(mapStateToProps)(MainPage);



// WEBPACK FOOTER //
// ./src/pages/MainPage/MainPage.js